import React, { useState, useEffect, useContext } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import PanelCardWithHeading from "components/tickets/panelCardWithHeading";
import CreateComplainForm from "components/fileComplain/formSection/createComplainForm/createComplainForm";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import ComplainList from "./complainList";

const CreateComplain = ({
  match,
  documentUploadUrl,
  documentUrlData,
  raiseComplain,
  getFormDropdowns,
  getComplains,
  formDropdowns,
  fetchFaqs,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [siteNo, setSiteNo] = useState();
  const [dropdownsData, setDropdownsData] = useState({});
  const [isModal, setIsModal] = useState(false);
  const [isFiled, setIsFiled] = useState(false);
  const [complainId, setComplainId] = useState("");
  const [showProjectListPopup, setShowProjectListPopup] = useState(false);
  const [complainList, setComplainList] = useState([]);

  useEffect(() => {
    setSiteNo(match.params.id);
  }, [match.params.id]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getFormDropdowns(match.params.id);
      setIsLoading(false);
    })();
  }, [getFormDropdowns]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const res = await getComplains(match.params.id);
      if(res?.response?.data?.resultSets.length > 0) {
        setShowProjectListPopup(true);
        setComplainList(res?.response?.data?.resultSets);
      }
      setIsLoading(false);
    })();
  }, [match.params.id]);

  useEffect(() => {
    if (formDropdowns.complain_raised_by) {
      setDropdownsData(formDropdowns);
    }
  }, [formDropdowns]);

  const raiseComplainHandle = async (val) => {
    if (val === null) {
      setIsFiled(true);
    } else {
      setIsFiled(true);
      setIsLoading(true);

      const res = await raiseComplain(val);
      if (res) {
        setIsLoading(false);
        setComplainId(res.complain_id);
        setIsModal(true);
      }
    }
  };

  const addNewComplain = () => {
    setShowProjectListPopup(false);
  }
  const hideComplain = () => {
    setShowProjectListPopup(false);
  }

  return (
    <Layout
      title={localization.createComplain}
      isLoading={isLoading}
      isGoback
      className={isFiled ? "requiredFileds" : ""}
    >
      <PanelCardWithHeading title={localization.createComplain}>
        <CreateComplainForm
          siteNo={siteNo}
          complainRaisedBy={dropdownsData.complain_raised_by || []}
          complainTypes={dropdownsData.complain_type || []}
          gates={dropdownsData.gates || []}
          category={dropdownsData.category || []}
          products={dropdownsData.product || []}
          materialRequired={dropdownsData.material_required || []}
          documentUploadUrl={documentUploadUrl}
          documentUrlData={documentUrlData}
          complainFormData={raiseComplainHandle}
          fetchFaqs={fetchFaqs}
        />
      </PanelCardWithHeading>

      <ComplainList
        showProjectListPopup={showProjectListPopup}
        onClosePopup={() => addNewComplain(false)}
        onCloseHidePopup={() => hideComplain(false)}  
        existingComplainList = {complainList} 
      />

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={() => setIsModal(false)}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.saveSuccessfully}</h5>
          <Link
            to={`${baseUrl}/view-complain/${complainId}`}
            className="btn btn-primary mb-4"
          >
            {localization.siteInformation}{" "}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

CreateComplain.propTypes = {};

export default CreateComplain;
